module.exports = __webpack_public_path__ + "static/title_frame-5c4f589db0e801407312d81f64e4ca85.png";